module.exports = __webpack_public_path__ + "img/builder-3.9dd0cb87.webp";